export const set_translation_fe_tree = (state, data) =>
  (state.translation_fe_tree = data);
export const set_translation_db_tree = (state, data) =>
  (state.translation_db_tree = data);
